import { Component, Input } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';

@Component({
    selector: 'c-loader',
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss',
    imports: [SharedModule]
})
export class LoaderComponent {
    @Input() color: 'primary' | 'secondary' | 'medium' | undefined = 'primary';
    @Input() loading = false;
}
